import EditIcon from "@mui/icons-material/Edit";
import { Chip, Text } from "designSystem/index";
import React from "react";
import CssColumnGrid from "designSystemLegacy/CssColumnGrid";

export default () => (
	<CssColumnGrid columns={6}>
		<Text semiBold text="default" />
		<Text semiBold text="default clickable" />
		<Text semiBold text="outlined with icon" />
		<Text semiBold text="outlined with icon and deletable" />
		<Text semiBold text="default and deletable" />
		<Text semiBold text="outlined deletable" />
		<Chip
			label="default"
		/>
		<Chip
			label="default clickable"
			onClick={() => { console.log("clickable"); }}
		/>
		<Chip
			icon={(<EditIcon />)}
			label="outlined with icon"
			variant="outlined"
		/>
		<Chip
			icon={(<EditIcon />)}
			label="outlined with icon and deletable"
			onDelete={() => { console.log("deletable"); }}
			variant="outlined"
		/>
		<Chip
			label="default and deletable"
			onDelete={() => { console.log("deletable"); }}
		/>
		<Chip
			label="outlined deletable"
			onDelete={() => { console.log("deletable"); }}
			variant="outlined"
		/>
	</CssColumnGrid>
);